<template>
    <div>
      <CreatePR/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import CreatePR from '@/components/CreatePR.vue'
  
  export default {
    name: 'create-pr-view',
    components: {
      CreatePR
    }
  }
  </script>
  